import { HollandCode } from './HollandCode';
import { Occupation } from './Occupation';

export class Character {
    public hollandCode: HollandCode;
    public id: number;
    public assignedOccupation: Occupation;
    public object: Phaser.Physics.Arcade.Image;
    public label: Phaser.GameObjects.Text;
    public enabled: boolean;
   
    constructor(id: number, hollandCode: HollandCode, object: Phaser.Physics.Arcade.Image) {
        this.hollandCode = hollandCode;
        this.id = id;
        this.assignedOccupation = null;
        this.object = object;
        this.label = null;
        this.enabled = true;
    }
}



// WEBPACK FOOTER //
// ./src/games/JobMatchingGame/objects/Character.ts